module.exports = __webpack_public_path__ + "img/obican-radio.ef6956ac.png";